import React, { useState, useEffect } from 'react';
import './game.css';

const Game = () => {
    const [cursorPosition, setCursorPosition] = useState({ x: 2, y: 1 });
    const [stars, setStars] = useState<string[]>([]);
    const [showNotClear, setShowNotClear] = useState(false);
    const [showClear, setShowClear] = useState(false);
    const [isClear, setIsClear] = useState(true);
    const maps = [1, 3, 10, 11, 12, 13, 21, 23, 31, 41];

    const answer = [['', 'B', '', '', ''], ['B', 'L', 'A', 'C', 'K'], ['', 'U', '', '', ''], ['R', 'E', 'D', '', '']];

    useEffect(() => {
        if (stars.length === 5) {
            setTimeout(() => {
                setStars([]);
                if (isClear) {
                    setShowClear(true);
                }
                else {
                    setShowNotClear(true);
                    setTimeout(() => {
                        setShowNotClear(false);
                        setIsClear(true);
                    }, 2000);
                }
            }, 1000);
        }
    }, [stars]);

    const moveCursor = (direction: string) => {
        let newX = cursorPosition.x;
        let newY = cursorPosition.y;

        switch (direction) {
            case 'up':
                if (maps.includes(newX * 10 + newY - 1)) {
                    newY = Math.max(newY - 1, 0);
                }
                break;
            case 'down':
                if (maps.includes(newX * 10 + newY + 1)) {
                    newY = Math.min(newY + 1, 3);
                }
                break;
            case 'left':
                if (maps.includes((newX - 1) * 10 + newY)) {
                    newX = Math.max(newX - 1, 0);
                }
                break;
            case 'right':
                if (maps.includes((newX + 1) * 10 + newY)) {
                    newX = Math.min(newX + 1, 4);
                }
                break;
            default:
                break;
        }

        setCursorPosition({ x: newX, y: newY });
    };

    const handleDecision = () => {
        if (stars.length < 5 && !showNotClear && !showClear) {
            switch (stars.length) {
                case 0:
                    setIsClear(isClear && cursorPosition.x === 3 && cursorPosition.y === 1);
                    break;
                case 1:
                    setIsClear(isClear && cursorPosition.x === 1 && cursorPosition.y === 1);
                    break;
                case 2:
                    setIsClear(isClear && cursorPosition.x === 1 && cursorPosition.y === 3);
                    break;
                case 3:
                    setIsClear(isClear && cursorPosition.x === 2 && cursorPosition.y === 1);
                    break;
                case 4:
                    setIsClear(isClear && cursorPosition.x === 0 && cursorPosition.y === 3);
                    break;
                default:
                    break;
            }
            setStars([...stars, '*']);
        }
    };

    return (
        <div className="board">
            <div className="title">
                <h1>Web謎「Colors」</h1>
                <p>
                    これは、Webページの挙動からシステムとクリア条件を推測してクリアを目指す、「宇宙謎」と呼ばれるジャンルの謎です。
                </p>
            </div>
            <div className="board-map">
                {[...Array(4)].map((_, y) => (
                    <div key={y} className="row">
                        {[...Array(5)].map((_, x) => (
                            <div
                                key={x}
                                className={`cell ${cursorPosition.x === x && cursorPosition.y === y ? 'cursor' : ''} 
                                ${cursorPosition.y === 1 && cursorPosition.x === x && cursorPosition.y === y ? 'black-cursor' : ''} 
                                ${cursorPosition.y === 3 && cursorPosition.x === x && cursorPosition.y === y ? 'red-cursor' : ''} 
                                ${cursorPosition.x === 1 && cursorPosition.x === x && cursorPosition.y === y ? 'blue-cursor' : ''}
                                ${cursorPosition.y === 1 && cursorPosition.x === 1 && cursorPosition.x === x && cursorPosition.y === y ? 'black-blue-cursor' : ''} 
                                ${cursorPosition.y === 3 && cursorPosition.x === 1 && cursorPosition.x === x && cursorPosition.y === y ? 'red-blue-cursor' : ''} 
                                `}
                            >
                                {showClear && <div>{answer[y][x]}</div>}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
            <div className="controls">
                <div className="left-right-buttons">
                    <button onClick={() => moveCursor('left')}><div className="arrow arrow-left"></div></button>
                </div>
                <div className="up-down-buttons">
                    <button onClick={() => moveCursor('up')}><div className="arrow arrow-up"></div></button>
                    <button onClick={() => moveCursor('down')}><div className="arrow arrow-down"></div></button>
                </div>
                <div className="left-right-buttons">
                    <button onClick={() => moveCursor('right')}><div className="arrow arrow-right"></div></button>
                </div>
                <div>
                    <button className="button-ok" onClick={handleDecision}>OK</button>
                </div>
            </div>
            <div className="texts">
                <div className="stars">{stars.map((star, index) => <span key={index}>{star}</span>)}</div>
                {showNotClear && <div className="not-clear">NOT CLEAR...</div>}
                {showClear && <div className="clear">CLEAR!</div>}
                {showClear && <div className="sns-button">
                    <a href="https://twitter.com/intent/tweet?text=%E2%96%A0%E2%96%A1%E2%96%A0%E2%96%A1%E2%96%A0%E2%96%A1%E2%96%A0%E2%96%A1%E2%96%A0%E2%96%A1%E2%96%A0%E2%96%A1%E2%96%A0%E2%96%A1%0D%0AWeb%E8%AC%8E%E3%80%8CColors%E3%80%8D%E3%82%92%E3%82%AF%E3%83%AA%E3%82%A2%E3%81%97%E3%81%9F%EF%BC%81%0D%0A%E2%96%A0%E2%96%A1%E2%96%A0%E2%96%A1%E2%96%A0%E2%96%A1%E2%96%A0%E2%96%A1%E2%96%A0%E2%96%A1%E2%96%A0%E2%96%A1%E2%96%A0%E2%96%A1%0D%0A%0D%0A%E3%83%97%E3%83%AC%E3%82%A4%E3%81%AF%E3%81%93%E3%81%A1%E3%82%89%E2%86%92+https%3A%2F%2Fridkmy.github.io%2FColors%0D%0A%0D%0A%23%E8%AC%8E%E8%A7%A3%E3%81%8D+%23Web%E8%AC%8E+%23Colors%E8%AC%8E+%40ridkmy+" target="_blank" rel="noopener noreferrer">Xでポストする</a>
                </div>}
            </div>
        </div>
    );
};

export default Game;